import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import PreviewContent from './previewContent';

import styles from '../styles/uikitContentMarkdown.module.scss';

const MarkdownLinkPreview = ({
  getLinkPreviewData,
  id,
  text,
  hrefPrefix = '/student/activity/',
  LinkPreview = null,
  linkTarget = '_blank',
  previewContentAlignment = 'topLeft',
}) => {
  const trigger = useRef(null);

  const data = getLinkPreviewData(id);

  const href = hrefPrefix + id;

  return (
    <span ref={trigger} className={LinkPreview ? styles.linkPreview : ''}>
      <a
        href={href}
        className={LinkPreview ? '' : styles.linkAnchor}
        target={linkTarget}
        rel="noopener noreferrer"
      >
        {text}
      </a>
      {LinkPreview && data && (
        <PreviewContent trigger={trigger} alignment={previewContentAlignment}>
          <LinkPreview data={data} />
        </PreviewContent>
      )}
    </span>
  );
};

MarkdownLinkPreview.propTypes = {
  getLinkPreviewData: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  hrefPrefix: PropTypes.string,
  LinkPreview: PropTypes.elementType,
  linkTarget: PropTypes.oneOf(['_blank', '_self', '_parent', '_top']),
  previewContentAlignment: PropTypes.oneOf([
    'topLeft',
    'bottomLeft',
    'topCenter',
    'bottomCenter',
    'topRight',
    'bottomRight',
  ]),
};

export default MarkdownLinkPreview;
